const contacts = '/contacts';
const companies = `${contacts}/companies`;
const people = `${contacts}/people`;
const tags = `${contacts}/tags`;

export const ROUTES = {
	contacts: {
		main: contacts,
		companies,
		people,
		tags,
	},
	dataBoards: {
		home: '/dataBoards',
		opportunities: '/dataBoards/opportunities',
		donations: '/dataBoards/donations',
		donationsImport: '/dataBoards/donations/import',
		policies: '/dataBoards/policies',
		contactSelfImport: '/dataBoards/policies/contacts-self-import',
	},
	airesolver: '/airesolver',
} as const;
